import ArticleBlock, { ArticleBlockTheme } from 'components/article-block/ArticleBlock';
import RelatedContent from 'components/related-content/RelatedContent';

import { IRelatedArticles } from 'source/NFR.types';

const RelatedArticles: React.FC<IRelatedArticles> = ({
  articles,
  relatedContent,
  usedInSidebar = false,
  isGrid = false,
  isPublication = false
}) => {
  const articleTheme = (): ArticleBlockTheme[] => {
    const themes: ArticleBlockTheme[] = ['noMargin'];
    if (usedInSidebar) themes.push('sidebar');
    if (isGrid) themes.push('vertical');
    if (isPublication) themes.push('publication');
    return themes;
  };

  const relatedContentProps = { ...relatedContent, isGrid };

  return (
    <RelatedContent {...relatedContentProps}>
      {articles?.map(article => (
        <ArticleBlock
          headingLevel={3}
          key={article.title?.text}
          theme={articleTheme()}
          {...article}
          usedInSidebar={usedInSidebar}
        />
      ))}
    </RelatedContent>
  );
};

RelatedArticles.displayName = 'RelatedArticles';

export default RelatedArticles;
